import { render, staticRenderFns } from "./Devices2.vue?vue&type=template&id=13fd8737"
import script from "./Devices2.vue?vue&type=script&lang=js"
export * from "./Devices2.vue?vue&type=script&lang=js"
import style0 from "./Devices2.vue?vue&type=style&index=0&id=13fd8737&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports